import { useRef } from 'react'
import { FormContentHandle, FormContentV2 } from './FormContentV2'
import { InferFormValues, JsonFormSchemaV2 } from './types'
import { useGetForm } from './useGetForm'
import { useSubmitForm } from './useSubmitForm'
import { useTileFilters } from '@/catalog-apps/hooks/useTileFilters'
import { TileFilter } from '../shared/TileFilter'
export const FormComponent = <TSchema extends JsonFormSchemaV2>(props: {
  id: string
  resetDefaults?: InferFormValues<TSchema>
  className?: string
}) => {
  const { tileFilterSelections } = useTileFilters()
  const { id, ...rest } = props
  const { data } = useGetForm(id, tileFilterSelections)
  const formRef = useRef<FormContentHandle>(null)

  type FormData = InferFormValues<typeof data.uiSchema.schema>
  const {
    actions: { handlerId },
  } = data.uiSchema

  const { mutateAsync: submitForm, isPending: isSubmitting } = useSubmitForm(handlerId, tileFilterSelections)

  const submitHandler = (formData: FormData) => {
    submitForm(formData).then((response) => {
      if (response.uiSchema.success === false) {
        return
      }
      if (formRef.current) {
        formRef.current.reset()
      }
    })
  }

  return (
    <FormContentV2
      ref={formRef}
      schema={data.uiSchema.schema}
      submitHandler={submitHandler}
      tileFilters={<TileFilter schema={data.filters} />}
      isSubmitting={isSubmitting}
      {...rest}
    />
  )
}
